import { Site } from "@/types/sites";
import OneSignal from 'react-onesignal';
import {useEffect} from 'react';

export const OneSignalWrapper = ({ site, hasOfferList }: { site: Site | null, hasOfferList: boolean }) => {
    const oneSignalId = site?.attributes?.third_party_scripts?.OneSignalAccountId;
    useEffect(() => {
      if (oneSignalId) {
          OneSignal.init({
              appId: oneSignalId,
              allowLocalhostAsSecureOrigin: true,
              notifyButton: {
                  enable: hasOfferList,
              },
              promptOptions: {
                  slidedown: {
                    type:'push',
                    enabled: true,
                    autoPrompt: hasOfferList,
                    timeDelay:3
                  },
              }
          })
      }
  }, [oneSignalId, hasOfferList]);

  return null;
};
